const wallpaperList = [
{
        "name": "Prism",
        "author": "undefyned",
        "url": "https://raw.githubusercontent.com/undefyned/wallpeppers/master/images/glitch/Prism.png",
        "thumbnail": "https://raw.githubusercontent.com/undefyned/wallpeppers/master/images/thumbs/glitch/Prism.webp",
        "collections": "ALL,GLITCH"
}, {
        "name": "Clout",
        "author": "undefyned",
        "url": "https://raw.githubusercontent.com/undefyned/wallpeppers/master/images/glitch/Clout.png",
        "thumbnail": "https://raw.githubusercontent.com/undefyned/wallpeppers/master/images/thumbs/glitch/Clout.webp",
        "collections": "ALL,GLITCH"
}, {
        "name": "pixlsortBeach",
        "author": "undefyned",
        "url": "https://raw.githubusercontent.com/undefyned/wallpeppers/master/images/glitch/pixlsortBeach.png",
        "thumbnail": "https://raw.githubusercontent.com/undefyned/wallpeppers/master/images/thumbs/glitch/pixlsortBeach.webp",
        "collections": "ALL,GLITCH"
}, {
        "name": "lightGlitch.wav",
        "author": "undefyned",
        "url": "https://raw.githubusercontent.com/undefyned/wallpeppers/master/images/glitch/lightGlitch.wav.png",
        "thumbnail": "https://raw.githubusercontent.com/undefyned/wallpeppers/master/images/thumbs/glitch/lightGlitch.wav.webp",
        "collections": "ALL,GLITCH"
}, {
        "name": "darkGlitch.wav",
        "author": "undefyned",
        "url": "https://raw.githubusercontent.com/undefyned/wallpeppers/master/images/glitch/darkGlitch.wav.png",
        "thumbnail": "https://raw.githubusercontent.com/undefyned/wallpeppers/master/images/thumbs/glitch/darkGlitch.wav.webp",
        "collections": "ALL,GLITCH"
}, {
        "name": "looksNiceNgl",
        "author": "undefyned",
        "url": "https://raw.githubusercontent.com/undefyned/wallpeppers/master/images/glitch/looksNiceNgl.png",
        "thumbnail": "https://raw.githubusercontent.com/undefyned/wallpeppers/master/images/thumbs/glitch/looksNiceNgl.webp",
        "collections": "ALL,GLITCH"
}, {
        "name": "looksNiceNglPart2",
        "author": "undefyned",
        "url": "https://raw.githubusercontent.com/undefyned/wallpeppers/master/images/glitch/looksNiceNglPart2.png",
        "thumbnail": "https://raw.githubusercontent.com/undefyned/wallpeppers/master/images/thumbs/glitch/looksNiceNglPart2.webp",
        "collections": "ALL,GLITCH"
}, {
        "name": "Liqd",
        "author": "undefyned",
        "url": "https://raw.githubusercontent.com/undefyned/wallpeppers/master/images/glitch/Liqd.png",
        "thumbnail": "https://raw.githubusercontent.com/undefyned/wallpeppers/master/images/thumbs/glitch/Liqd.webp",
        "collections": "ALL,GLITCH"
}, {
        "name": "LiqdAgain",
        "author": "undefyned",
        "url": "https://raw.githubusercontent.com/undefyned/wallpeppers/master/images/glitch/LiqdAgain.png",
        "thumbnail": "https://raw.githubusercontent.com/undefyned/wallpeppers/master/images/thumbs/glitch/LiqdAgain.webp",
        "collections": "ALL,GLITCH"
}, {
        "name": "LiqdShiny",
        "author": "undefyned",
        "url": "https://raw.githubusercontent.com/undefyned/wallpeppers/master/images/glitch/LiqdShiny.png",
        "thumbnail": "https://raw.githubusercontent.com/undefyned/wallpeppers/master/images/thumbs/glitch/LiqdShiny.webp",
        "collections": "ALL,GLITCH"
}, {
        "name": "LiqdAgainShiny",
        "author": "undefyned",
        "url": "https://raw.githubusercontent.com/undefyned/wallpeppers/master/images/glitch/LiqdAgainShiny.png",
        "thumbnail": "https://raw.githubusercontent.com/undefyned/wallpeppers/master/images/thumbs/glitch/LiqdAgainShiny.webp",
        "collections": "ALL,GLITCH"
}, {
        "name": "Falling Stars",
        "author": "undefyned",
        "url": "https://raw.githubusercontent.com/undefyned/wallpeppers/master/images/glitch/fallingstars.png",
        "thumbnail": "https://raw.githubusercontent.com/undefyned/wallpeppers/master/images/thumbs/glitch/fallingstars.webp",
        "collections": "ALL,GLITCH"
}, {
        "name": "Flow Light",
        "author": "undefyned",
        "url": "https://raw.githubusercontent.com/undefyned/wallpeppers/master/images/glitch/flow-light.png",
        "thumbnail": "https://raw.githubusercontent.com/undefyned/wallpeppers/master/images/thumbs/glitch/flow-light.webp",
        "collections": "ALL,GLITCH"
}, {
        "name": "Flow Dark",
        "author": "undefyned",
        "url": "https://raw.githubusercontent.com/undefyned/wallpeppers/master/images/glitch/flow-dark.png",
        "thumbnail": "https://raw.githubusercontent.com/undefyned/wallpeppers/master/images/thumbs/glitch/flow-dark.webp",
        "collections": "ALL,GLITCH"
}, {
        "name": "Colors, Yes.",
        "author": "undefyned",
        "url": "https://raw.githubusercontent.com/undefyned/wallpeppers/master/images/glitch/colorsyes.png",
        "thumbnail": "https://raw.githubusercontent.com/undefyned/wallpeppers/master/images/thumbs/glitch/colorsyes.webp",
        "collections": "ALL,GLITCH"
}, {
        "name": "Nice",
        "author": "undefyned",
        "url": "https://raw.githubusercontent.com/undefyned/wallpeppers/master/images/glitch/nice.png",
        "thumbnail": "https://raw.githubusercontent.com/undefyned/wallpeppers/master/images/thumbs/glitch/nice.webp",
        "collections": "ALL,GLITCH"
}, {
        "name": "Marble Something",
        "author": "undefyned",
        "url": "https://raw.githubusercontent.com/undefyned/wallpeppers/master/images/glitch/somemarblething.png",
        "thumbnail": "https://raw.githubusercontent.com/undefyned/wallpeppers/master/images/thumbs/glitch/somemarblething.webp",
        "collections": "ALL,GLITCH"
}, {
        "name": "Something Glitchy",
        "author": "undefyned",
        "url": "https://raw.githubusercontent.com/undefyned/wallpeppers/master/images/glitch/somethingglitchy.png",
        "thumbnail": "https://raw.githubusercontent.com/undefyned/wallpeppers/master/images/thumbs/glitch/somethingglitchy.webp",
        "collections": "ALL,GLITCH"
}, {
        "name": "Bzzz",
        "author": "undefyned",
        "url": "https://raw.githubusercontent.com/undefyned/wallpeppers/master/images/glitch/bzzz.png",
        "thumbnail": "https://raw.githubusercontent.com/undefyned/wallpeppers/master/images/thumbs/glitch/bzzz.webp",
        "collections": "ALL,GLITCH"
}, {
        "name": "RGB Wave",
        "author": "undefyned",
        "url": "https://raw.githubusercontent.com/undefyned/wallpeppers/master/images/glitch/rgbwave.png",
        "thumbnail": "https://raw.githubusercontent.com/undefyned/wallpeppers/master/images/thumbs/glitch/rgbwave.webp",
        "collections": "ALL,GLITCH"
}, {
        "name": "It's bland!",
        "author": "undefyned",
        "url": "https://raw.githubusercontent.com/undefyned/wallpeppers/master/images/glitch/itsbland.png",
        "thumbnail": "https://raw.githubusercontent.com/undefyned/wallpeppers/master/images/thumbs/glitch/itsbland.webp",
        "collections": "ALL,GLITCH"
}, {
        "name": "Idk ok",
        "author": "undefyned",
        "url": "https://raw.githubusercontent.com/undefyned/wallpeppers/master/images/glitch/idontreallyknow.png",
        "thumbnail": "https://raw.githubusercontent.com/undefyned/wallpeppers/master/images/thumbs/glitch/idontreallyknow.webp",
        "collections": "ALL,GLITCH"
}, {
        "name": "Loop V",
        "author": "undefyned",
        "url": "https://raw.githubusercontent.com/undefyned/wallpeppers/master/images/patterns/LoopV.png",
        "thumbnail": "https://raw.githubusercontent.com/undefyned/wallpeppers/master/images/thumbs/patterns/LoopV.webp",
        "collections": "ALL,PATTERNS"
}, {
        "name": "Loop O",
        "author": "undefyned",
        "url": "https://raw.githubusercontent.com/undefyned/wallpeppers/master/images/patterns/LoopO.png",
        "thumbnail": "https://raw.githubusercontent.com/undefyned/wallpeppers/master/images/thumbs/patterns/LoopO.webp",
        "collections": "ALL,PATTERNS"
}, {
        "name": "Loop I",
        "author": "undefyned",
        "url": "https://raw.githubusercontent.com/undefyned/wallpeppers/master/images/patterns/LoopI.png",
        "thumbnail": "https://raw.githubusercontent.com/undefyned/wallpeppers/master/images/thumbs/patterns/LoopI.webp",
        "collections": "ALL,PATTERNS"
}, {
        "name": "Loop D",
        "author": "undefyned",
        "url": "https://raw.githubusercontent.com/undefyned/wallpeppers/master/images/patterns/LoopD.png",
        "thumbnail": "https://raw.githubusercontent.com/undefyned/wallpeppers/master/images/thumbs/patterns/LoopD.webp",
        "collections": "ALL,PATTERNS"
}, {
        "name": "Blobs Dark 2",
        "author": "undefyned",
        "url": "https://raw.githubusercontent.com/undefyned/wallpeppers/master/images/exclusive/Blobs%20Dark%202.png",
        "thumbnail": "https://raw.githubusercontent.com/undefyned/wallpeppers/master/images/thumbs/exclusive/Blobs%20Dark%202.webp",
        "collections": "ALL,EXCLUSIVE"
}, {
        "name": "Blobs Light 2",
        "author": "undefyned",
        "url": "https://raw.githubusercontent.com/undefyned/wallpeppers/master/images/exclusive/Blobs%20Light%202.png",
        "thumbnail": "https://raw.githubusercontent.com/undefyned/wallpeppers/master/images/thumbs/exclusive/Blobs%20Light%202.webp",
        "collections": "ALL,EXCLUSIVE"
}, {
        "name": "Christmas",
        "author": "undefyned",
        "url": "https://raw.githubusercontent.com/undefyned/wallpeppers/master/images/festive/CHRISTMAS.png",
        "thumbnail": "https://raw.githubusercontent.com/undefyned/wallpeppers/master/images/thumbs/festive/CHRISTMAS.webp",
        "collections": "ALL,FESTIVE"
}, {
        "name": "Christmas AMOLED",
        "author": "undefyned",
        "url": "https://raw.githubusercontent.com/undefyned/wallpeppers/master/images/festive/CHRISTMAS%20AMOLED.png",
        "thumbnail": "https://raw.githubusercontent.com/undefyned/wallpeppers/master/images/thumbs/festive/CHRISTMAS%20AMOLED.webp",
        "collections": "ALL,FESTIVE"
}, {
        "name": "Christmas Light",
        "author": "undefyned",
        "url": "https://raw.githubusercontent.com/undefyned/wallpeppers/master/images/festive/CHRISTMAS%20LIGHT.png",
        "thumbnail": "https://raw.githubusercontent.com/undefyned/wallpeppers/master/images/thumbs/festive/CHRISTMAS%20LIGHT.webp",
        "collections": "ALL,FESTIVE"
}, {
        "name": "Santa",
        "author": "undefyned",
        "url": "https://raw.githubusercontent.com/undefyned/wallpeppers/master/images/festive/SANTA.png",
        "thumbnail": "https://raw.githubusercontent.com/undefyned/wallpeppers/master/images/thumbs/festive/SANTA.webp",
        "collections": "ALL,FESTIVE"
}, {
        "name": "Santa 2",
        "author": "undefyned",
        "url": "https://raw.githubusercontent.com/undefyned/wallpeppers/master/images/festive/SANTA%202.png",
        "thumbnail": "https://raw.githubusercontent.com/undefyned/wallpeppers/master/images/thumbs/festive/SANTA%202.webp",
        "collections": "ALL,FESTIVE"
}, {
        "name": "Blobs Dark",
        "author": "undefyned",
        "url": "https://raw.githubusercontent.com/undefyned/wallpeppers/master/images/exclusive/Blobs%20Dark.png",
        "thumbnail": "https://raw.githubusercontent.com/undefyned/wallpeppers/master/images/thumbs/exclusive/Blobs%20Dark.webp",
        "collections": "ALL,EXCLUSIVE"
}, {
        "name": "Blobs Light",
        "author": "undefyned",
        "url": "https://raw.githubusercontent.com/undefyned/wallpeppers/master/images/exclusive/Blobs%20Light.png",
        "thumbnail": "https://raw.githubusercontent.com/undefyned/wallpeppers/master/images/thumbs/exclusive/Blobs%20Light.webp",
        "collections": "ALL,EXCLUSIVE"
}, {
        "name": "FLxRW Gloom",
        "author": "undefyned",
        "url": "https://raw.githubusercontent.com/undefyned/wallpeppers/master/images/exclusive/FLXRW%20GLOOM.png",
        "thumbnail": "https://raw.githubusercontent.com/undefyned/wallpeppers/master/images/thumbs/exclusive/FLXRW%20GLOOM.webp",
        "collections": "ALL,EXCLUSIVE"
}, {
        "name": "FLxRW Dawn",
        "author": "undefyned",
        "url": "https://raw.githubusercontent.com/undefyned/wallpeppers/master/images/exclusive/FLXRW%20DAWN.png",
        "thumbnail": "https://raw.githubusercontent.com/undefyned/wallpeppers/master/images/thumbs/exclusive/FLXRW%20DAWN.webp",
        "collections": "ALL,EXCLUSIVE"
}, {
        "name": "FLxRW Achromatic",
        "author": "undefyned",
        "url": "https://raw.githubusercontent.com/undefyned/wallpeppers/master/images/exclusive/FLXRW%20ACHROMATIC.png",
        "thumbnail": "https://raw.githubusercontent.com/undefyned/wallpeppers/master/images/thumbs/exclusive/FLXRW%20ACHROMATIC.webp",
        "collections": "ALL,EXCLUSIVE"
}, {
        "name": "Zig",
        "author": "undefyned",
        "url": "https://raw.githubusercontent.com/undefyned/wallpeppers/master/images/minimal/ZIG.png",
        "thumbnail": "https://raw.githubusercontent.com/undefyned/wallpeppers/master/images/thumbs/minimal/ZIG.webp",
        "collections": "ALL,MINIMAL"
}, {
        "name": "Zag",
        "author": "undefyned",
        "url": "https://raw.githubusercontent.com/undefyned/wallpeppers/master/images/minimal/ZAG.png",
        "thumbnail": "https://raw.githubusercontent.com/undefyned/wallpeppers/master/images/thumbs/minimal/ZAG.webp",
        "collections": "ALL,MINIMAL"
}, {
        "name": "XS1 AMOLED",
        "author": "undefyned",
        "url": "https://raw.githubusercontent.com/undefyned/wallpeppers/master/images/exclusive/XS1%20AMOLED.png",
        "thumbnail": "https://raw.githubusercontent.com/undefyned/wallpeppers/master/images/thumbs/exclusive/XS1%20AMOLED.webp",
        "collections": "ALL,EXCLUSIVE"
}, {
        "name": "XS2 AMOLED",
        "author": "undefyned",
        "url": "https://raw.githubusercontent.com/undefyned/wallpeppers/master/images/exclusive/XS2%20AMOLED.png",
        "thumbnail": "https://raw.githubusercontent.com/undefyned/wallpeppers/master/images/thumbs/exclusive/XS2%20AMOLED.webp",
        "collections": "ALL,EXCLUSIVE"
}, {
        "name": "XS3 Light",
        "author": "undefyned",
        "url": "https://raw.githubusercontent.com/undefyned/wallpeppers/master/images/exclusive/XS3%20LIGHT.png",
        "thumbnail": "https://raw.githubusercontent.com/undefyned/wallpeppers/master/images/thumbs/exclusive/XS3%20LIGHT.webp",
        "collections": "ALL,EXCLUSIVE"
}, {
        "name": "XS4 Neon",
        "author": "undefyned",
        "url": "https://raw.githubusercontent.com/undefyned/wallpeppers/master/images/exclusive/XS4%20NEON.png",
        "thumbnail": "https://raw.githubusercontent.com/undefyned/wallpeppers/master/images/thumbs/exclusive/XS4%20NEON.webp",
        "collections": "ALL,EXCLUSIVE"
}, {
        "name": "XYZX",
        "author": "undefyned",
        "url": "https://raw.githubusercontent.com/undefyned/wallpeppers/master/images/textual/XYZX.png",
        "thumbnail": "https://raw.githubusercontent.com/undefyned/wallpeppers/master/images/thumbs/textual/XYZX.webp",
        "collections": "ALL,MINIMAL"
}, {
        "name": "Redtangled",
        "author": "undefyned",
        "url": "https://raw.githubusercontent.com/undefyned/wallpeppers/master/images/inspired/REDTANGLED.png",
        "thumbnail": "https://raw.githubusercontent.com/undefyned/wallpeppers/master/images/thumbs/inspired/REDTANGLED.webp",
        "collections": "ALL,INSPIRED"
}, {
        "name": "3N Purple",
        "author": "undefyned",
        "url": "https://raw.githubusercontent.com/undefyned/wallpeppers/master/images/patterns/3N%20PURPLE.png",
        "thumbnail": "https://raw.githubusercontent.com/undefyned/wallpeppers/master/images/thumbs/patterns/3N%20PURPLE.webp",
        "collections": "ALL,PATTERNS"
}, {
        "name": "3N Red",
        "author": "undefyned",
        "url": "https://raw.githubusercontent.com/undefyned/wallpeppers/master/images/patterns/3N%20RED.png",
        "thumbnail": "https://raw.githubusercontent.com/undefyned/wallpeppers/master/images/thumbs/patterns/3N%20RED.webp",
        "collections": "ALL,PATTERNS"
}, {
        "name": "Fries",
        "author": "undefyned",
        "url": "https://raw.githubusercontent.com/undefyned/wallpeppers/master/images/textual/FRIES.png",
        "thumbnail": "https://raw.githubusercontent.com/undefyned/wallpeppers/master/images/thumbs/textual/FRIES.webp",
        "collections": "ALL,MINIMAL"
}, {
        "name": "Fries AMOLED",
        "author": "undefyned",
        "url": "https://raw.githubusercontent.com/undefyned/wallpeppers/master/images/textual/FRIES%20AMOLED.png",
        "thumbnail": "https://raw.githubusercontent.com/undefyned/wallpeppers/master/images/thumbs/textual/FRIES%20AMOLED.webp",
        "collections": "ALL,MINIMAL"
}, {
        "name": "Pills",
        "author": "undefyned",
        "url": "https://raw.githubusercontent.com/undefyned/wallpeppers/master/images/patterns/PILLS.png",
        "thumbnail": "https://raw.githubusercontent.com/undefyned/wallpeppers/master/images/thumbs/patterns/PILLS.webp",
        "collections": "ALL,PATTERNS"
}, {
        "name": "Pills Dark",
        "author": "undefyned",
        "url": "https://raw.githubusercontent.com/undefyned/wallpeppers/master/images/patterns/PILLS%20DARK.png",
        "thumbnail": "https://raw.githubusercontent.com/undefyned/wallpeppers/master/images/thumbs/patterns/PILLS%20DARK.webp",
        "collections": "ALL,PATTERNS"
}, {
        "name": "Spiral Neon",
        "author": "undefyned",
        "url": "https://raw.githubusercontent.com/undefyned/wallpeppers/master/images/patterns/SPIRAL%20NEON.png",
        "thumbnail": "https://raw.githubusercontent.com/undefyned/wallpeppers/master/images/thumbs/patterns/SPIRAL%20NEON.webp",
        "collections": "ALL,PATTERNS"
}, {
        "name": "Spiral AMOLED",
        "author": "undefyned",
        "url": "https://raw.githubusercontent.com/undefyned/wallpeppers/master/images/patterns/SPIRAL%20AMOLED.png",
        "thumbnail": "https://raw.githubusercontent.com/undefyned/wallpeppers/master/images/thumbs/patterns/SPIRAL%20AMOLED.webp",
        "collections": "ALL,PATTERNS"
}, {
        "name": "Flux",
        "author": "undefyned",
        "url": "https://raw.githubusercontent.com/undefyned/wallpeppers/master/images/patterns/FLUX.png",
        "thumbnail": "https://raw.githubusercontent.com/undefyned/wallpeppers/master/images/thumbs/patterns/FLUX.webp",
        "collections": "ALL,PATTERNS"
}, {
        "name": "Velvet",
        "author": "undefyned",
        "url": "https://raw.githubusercontent.com/undefyned/wallpeppers/master/images/patterns/VELVET.png",
        "thumbnail": "https://raw.githubusercontent.com/undefyned/wallpeppers/master/images/thumbs/patterns/VELVET.webp",
        "collections": "ALL,PATTERNS"
}, {
        "name": "Fibre",
        "author": "undefyned",
        "url": "https://raw.githubusercontent.com/undefyned/wallpeppers/master/images/patterns/FIBRE.png",
        "thumbnail": "https://raw.githubusercontent.com/undefyned/wallpeppers/master/images/thumbs/patterns/FIBRE.webp",
        "collections": "ALL,PATTERNS"
}, {
        "name": "Spook",
        "author": "undefyned",
        "url": "https://raw.githubusercontent.com/undefyned/wallpeppers/master/images/exclusive/SPOOK.png",
        "thumbnail": "https://raw.githubusercontent.com/undefyned/wallpeppers/master/images/thumbs/exclusive/SPOOK.webp",
        "collections": "ALL,EXCLUSIVE"
}, {
        "name": "Daunt",
        "author": "undefyned",
        "url": "https://raw.githubusercontent.com/undefyned/wallpeppers/master/images/exclusive/DAUNT.png",
        "thumbnail": "https://raw.githubusercontent.com/undefyned/wallpeppers/master/images/thumbs/exclusive/DAUNT.webp",
        "collections": "ALL,EXCLUSIVE"
}, {
        "name": "Sprout",
        "author": "undefyned",
        "url": "https://raw.githubusercontent.com/undefyned/wallpeppers/master/images/minimal/SPROUT.png",
        "thumbnail": "https://raw.githubusercontent.com/undefyned/wallpeppers/master/images/thumbs/minimal/SPROUT.webp",
        "collections": "ALL,MINIMAL"
}, {
        "name": "Texts",
        "author": "undefyned",
        "url": "https://raw.githubusercontent.com/undefyned/wallpeppers/master/images/patterns/TEXTS.png",
        "thumbnail": "https://raw.githubusercontent.com/undefyned/wallpeppers/master/images/thumbs/patterns/TEXTS.webp",
        "collections": "ALL,PATTERNS"
}, {
        "name": "UIXD",
        "author": "undefyned",
        "url": "https://raw.githubusercontent.com/undefyned/wallpeppers/master/images/exclusive/UIXD.png",
        "thumbnail": "https://raw.githubusercontent.com/undefyned/wallpeppers/master/images/thumbs/exclusive/UIXD.webp",
        "collections": "ALL,EXCLUSIVE"
}, {
        "name": "Wilderness",
        "author": "undefyned",
        "url": "https://raw.githubusercontent.com/undefyned/wallpeppers/master/images/exclusive/WILDERNESS.png",
        "thumbnail": "https://raw.githubusercontent.com/undefyned/wallpeppers/master/images/thumbs/exclusive/WILDERNESS.webp",
        "collections": "ALL,EXCLUSIVE"
}, {
        "name": "Stax X",
        "author": "undefyned",
        "url": "https://raw.githubusercontent.com/undefyned/wallpeppers/master/images/exclusive/STAX%20X.png",
        "thumbnail": "https://raw.githubusercontent.com/undefyned/wallpeppers/master/images/thumbs/exclusive/STAX%20X.webp",
        "collections": "ALL,EXCLUSIVE"
}, {
        "name": "Stax Y",
        "author": "undefyned",
        "url": "https://raw.githubusercontent.com/undefyned/wallpeppers/master/images/exclusive/STAX%20Y.png",
        "thumbnail": "https://raw.githubusercontent.com/undefyned/wallpeppers/master/images/thumbs/exclusive/STAX%20Y.webp",
        "collections": "ALL,EXCLUSIVE"
}, {
        "name": "Shapd",
        "author": "undefyned",
        "url": "https://raw.githubusercontent.com/undefyned/wallpeppers/master/images/minimal/SHAPD.png",
        "thumbnail": "https://raw.githubusercontent.com/undefyned/wallpeppers/master/images/thumbs/minimal/SHAPD.webp",
        "collections": "ALL,MINIMAL"
}, {
        "name": "Shapd AMOLED",
        "author": "undefyned",
        "url": "https://raw.githubusercontent.com/undefyned/wallpeppers/master/images/minimal/SHAPD%20AMOLED.png",
        "thumbnail": "https://raw.githubusercontent.com/undefyned/wallpeppers/master/images/thumbs/minimal/SHAPD%20AMOLED.webp",
        "collections": "ALL,MINIMAL"
}, {
        "name": "Spiral",
        "author": "undefyned",
        "url": "https://raw.githubusercontent.com/undefyned/wallpeppers/master/images/patterns/SPIRAL.png",
        "thumbnail": "https://raw.githubusercontent.com/undefyned/wallpeppers/master/images/thumbs/patterns/SPIRAL.webp",
        "collections": "ALL,PATTERNS"
}, {
        "name": "Float3",
        "author": "undefyned",
        "url": "https://raw.githubusercontent.com/undefyned/wallpeppers/master/images/minimal/FLOAT3.png",
        "thumbnail": "https://raw.githubusercontent.com/undefyned/wallpeppers/master/images/thumbs/minimal/FLOAT3.webp",
        "collections": "ALL,MINIMAL"
}, {
        "name": "Lost Light",
        "author": "undefyned",
        "url": "https://raw.githubusercontent.com/undefyned/wallpeppers/master/images/minimal/LOST%20LIGHT.png",
        "thumbnail": "https://raw.githubusercontent.com/undefyned/wallpeppers/master/images/thumbs/minimal/LOST%20LIGHT.webp",
        "collections": "ALL,MINIMAL"
}, {
        "name": "Lost AMOLED",
        "author": "undefyned",
        "url": "https://raw.githubusercontent.com/undefyned/wallpeppers/master/images/minimal/LOST%20AMOLED.png",
        "thumbnail": "https://raw.githubusercontent.com/undefyned/wallpeppers/master/images/thumbs/minimal/LOST%20AMOLED.webp",
        "collections": "ALL,MINIMAL"
}, {
        "name": "Gradient Scales",
        "author": "undefyned",
        "url": "https://raw.githubusercontent.com/undefyned/wallpeppers/master/images/gradients/GRADIENT%20SCALES.png",
        "thumbnail": "https://raw.githubusercontent.com/undefyned/wallpeppers/master/images/thumbs/gradients/GRADIENT%20SCALES.webp",
        "collections": "ALL,GRADIENTS"
}, {
        "name": "WASD Blu",
        "author": "undefyned",
        "url": "https://raw.githubusercontent.com/undefyned/wallpeppers/master/images/inspired/WASD%20BLU.png",
        "thumbnail": "https://raw.githubusercontent.com/undefyned/wallpeppers/master/images/thumbs/inspired/WASD%20BLU.webp",
        "collections": "ALL,INSPIRED"
}, {
        "name": "WASD Red",
        "author": "undefyned",
        "url": "https://raw.githubusercontent.com/undefyned/wallpeppers/master/images/inspired/WASD%20RED.png",
        "thumbnail": "https://raw.githubusercontent.com/undefyned/wallpeppers/master/images/thumbs/inspired/WASD%20RED.webp",
        "collections": "ALL,INSPIRED"
}, {
        "name": "MNML Blu",
        "author": "undefyned",
        "url": "https://raw.githubusercontent.com/undefyned/wallpeppers/master/images/inspired/MNML%20BLU.png",
        "thumbnail": "https://raw.githubusercontent.com/undefyned/wallpeppers/master/images/thumbs/inspired/MNML%20BLU.webp",
        "collections": "ALL,INSPIRED"
}, {
        "name": "MNML Red",
        "author": "undefyned",
        "url": "https://raw.githubusercontent.com/undefyned/wallpeppers/master/images/inspired/MNML%20RED.png",
        "thumbnail": "https://raw.githubusercontent.com/undefyned/wallpeppers/master/images/thumbs/inspired/MNML%20RED.webp",
        "collections": "ALL,INSPIRED"
}, {
        "name": "Trxy",
        "author": "undefyned",
        "url": "https://raw.githubusercontent.com/undefyned/wallpeppers/master/images/patterns/TRXY.png",
        "thumbnail": "https://raw.githubusercontent.com/undefyned/wallpeppers/master/images/thumbs/patterns/TRXY.webp",
        "collections": "ALL,PATTERNS"
}, {
        "name": "Blocks",
        "author": "undefyned",
        "url": "https://raw.githubusercontent.com/undefyned/wallpeppers/master/images/minimal/BLOCKS.png",
        "thumbnail": "https://raw.githubusercontent.com/undefyned/wallpeppers/master/images/thumbs/minimal/BLOCKS.webp",
        "collections": "ALL,MINIMAL"
}, {
        "name": "Sym Night",
        "author": "undefyned",
        "url": "https://raw.githubusercontent.com/undefyned/wallpeppers/master/images/patterns/SYM%20NIGHT.png",
        "thumbnail": "https://raw.githubusercontent.com/undefyned/wallpeppers/master/images/thumbs/patterns/SYM%20NIGHT.webp",
        "collections": "ALL,PATTERNS"
}, {
        "name": "Sym AMOLED",
        "author": "undefyned",
        "url": "https://raw.githubusercontent.com/undefyned/wallpeppers/master/images/patterns/SYM%20AMOLED.png",
        "thumbnail": "https://raw.githubusercontent.com/undefyned/wallpeppers/master/images/thumbs/patterns/SYM%20AMOLED.webp",
        "collections": "ALL,PATTERNS"
}, {
        "name": "Gradient Slices",
        "author": "undefyned",
        "url": "https://raw.githubusercontent.com/undefyned/wallpeppers/master/images/gradients/GRADIENT%20SLICES.png",
        "thumbnail": "https://raw.githubusercontent.com/undefyned/wallpeppers/master/images/thumbs/gradients/GRADIENT%20SLICES.webp",
        "collections": "ALL,GRADIENTS"
}, {
        "name": "Gradient Z",
        "author": "undefyned",
        "url": "https://raw.githubusercontent.com/undefyned/wallpeppers/master/images/gradients/GRADIENT%20Z.png",
        "thumbnail": "https://raw.githubusercontent.com/undefyned/wallpeppers/master/images/thumbs/gradients/GRADIENT%20Z.webp",
        "collections": "ALL,GRADIENTS"
}, {
        "name": "Illusion Buttons",
        "author": "undefyned",
        "url": "https://raw.githubusercontent.com/undefyned/wallpeppers/master/images/illusion/ILLUSION%20BUTTONS.png",
        "thumbnail": "https://raw.githubusercontent.com/undefyned/wallpeppers/master/images/thumbs/illusion/ILLUSION%20BUTTONS.webp",
        "collections": "ALL,ILLUSION"
}, {
        "name": "Illusion",
        "author": "undefyned",
        "url": "https://raw.githubusercontent.com/undefyned/wallpeppers/master/images/illusion/ILLUSION.png",
        "thumbnail": "https://raw.githubusercontent.com/undefyned/wallpeppers/master/images/thumbs/illusion/ILLUSION.webp",
        "collections": "ALL,ILLUSION"
}, {
        "name": "Illusion II",
        "author": "undefyned",
        "url": "https://raw.githubusercontent.com/undefyned/wallpeppers/master/images/illusion/ILLUSION%20II.png",
        "thumbnail": "https://raw.githubusercontent.com/undefyned/wallpeppers/master/images/thumbs/illusion/ILLUSION%20II.webp",
        "collections": "ALL,ILLUSION"
}, {
        "name": "Cubes",
        "author": "undefyned",
        "url": "https://raw.githubusercontent.com/undefyned/wallpeppers/master/images/illusion/CUBES.png",
        "thumbnail": "https://raw.githubusercontent.com/undefyned/wallpeppers/master/images/thumbs/illusion/CUBES.webp",
        "collections": "ALL,ILLUSION"
}, {
        "name": "GLXY",
        "author": "undefyned",
        "url": "https://raw.githubusercontent.com/undefyned/wallpeppers/master/images/space/GLXY.png",
        "thumbnail": "https://raw.githubusercontent.com/undefyned/wallpeppers/master/images/thumbs/space/GLXY.webp",
        "collections": "ALL,SPACE"
}, {
        "name": "GLXY ALT",
        "author": "undefyned",
        "url": "https://raw.githubusercontent.com/undefyned/wallpeppers/master/images/space/GLXY%20ALT.png",
        "thumbnail": "https://raw.githubusercontent.com/undefyned/wallpeppers/master/images/thumbs/space/GLXY%20ALT.webp",
        "collections": "ALL,SPACE"
}, {
        "name": "Pencil",
        "author": "undefyned",
        "url": "https://raw.githubusercontent.com/undefyned/wallpeppers/master/images/minimal/PENCIL.png",
        "thumbnail": "https://raw.githubusercontent.com/undefyned/wallpeppers/master/images/thumbs/minimal/PENCIL.webp",
        "collections": "ALL,MINIMAL"
}, {
        "name": "Pencil AMOLED",
        "author": "undefyned",
        "url": "https://raw.githubusercontent.com/undefyned/wallpeppers/master/images/minimal/PENCIL%20AMOLED.png",
        "thumbnail": "https://raw.githubusercontent.com/undefyned/wallpeppers/master/images/thumbs/minimal/PENCIL%20AMOLED.webp",
        "collections": "ALL,MINIMAL"
}, {
        "name": "Stripes",
        "author": "undefyned",
        "url": "https://raw.githubusercontent.com/undefyned/wallpeppers/master/images/minimal/STRIPES.png",
        "thumbnail": "https://raw.githubusercontent.com/undefyned/wallpeppers/master/images/thumbs/minimal/STRIPES.webp",
        "collections": "ALL,MINIMAL"
}, {
        "name": "Rise",
        "author": "undefyned",
        "url": "https://raw.githubusercontent.com/undefyned/wallpeppers/master/images/inspired/RISE.png",
        "thumbnail": "https://raw.githubusercontent.com/undefyned/wallpeppers/master/images/thumbs/inspired/RISE.webp",
        "collections": "ALL,INSPIRED"
}, {
        "name": "Rise Vibrant",
        "author": "undefyned",
        "url": "https://raw.githubusercontent.com/undefyned/wallpeppers/master/images/inspired/RISE%20VIBRANT.png",
        "thumbnail": "https://raw.githubusercontent.com/undefyned/wallpeppers/master/images/thumbs/inspired/RISE%20VIBRANT.webp",
        "collections": "ALL,INSPIRED"
}, {
        "name": "T-Rex Silhouette",
        "author": "undefyned",
        "url": "https://raw.githubusercontent.com/undefyned/wallpeppers/master/images/minimal/TREX%20SILHOUETTE.png",
        "thumbnail": "https://raw.githubusercontent.com/undefyned/wallpeppers/master/images/thumbs/minimal/TREX%20SILHOUETTE.webp",
        "collections": "ALL,MINIMAL"
}, {
        "name": "T-Rex Red",
        "author": "undefyned",
        "url": "https://raw.githubusercontent.com/undefyned/wallpeppers/master/images/minimal/TREX%20RED.png",
        "thumbnail": "https://raw.githubusercontent.com/undefyned/wallpeppers/master/images/thumbs/minimal/TREX%20RED.webp",
        "collections": "ALL,MINIMAL"
}, {
        "name": "Zap",
        "author": "undefyned",
        "url": "https://raw.githubusercontent.com/undefyned/wallpeppers/master/images/minimal/ZAP.png",
        "thumbnail": "https://raw.githubusercontent.com/undefyned/wallpeppers/master/images/thumbs/minimal/ZAP.webp",
        "collections": "ALL,MINIMAL"
}, {
        "name": "Carbon Fiber",
        "author": "undefyned",
        "url": "https://raw.githubusercontent.com/undefyned/wallpeppers/master/images/patterns/CARBON%20FIBER.png",
        "thumbnail": "https://raw.githubusercontent.com/undefyned/wallpeppers/master/images/thumbs/patterns/CARBON%20FIBER.webp",
        "collections": "ALL,PATTERNS"
}, {
        "name": "Tiled Pattern",
        "author": "undefyned",
        "url": "https://raw.githubusercontent.com/undefyned/wallpeppers/master/images/patterns/TILED%20PATTERN.png",
        "thumbnail": "https://raw.githubusercontent.com/undefyned/wallpeppers/master/images/thumbs/patterns/TILED%20PATTERN.webp",
        "collections": "ALL,PATTERNS"
}, {
        "name": "Aquarius AMOLED",
        "author": "undefyned",
        "url": "https://raw.githubusercontent.com/undefyned/wallpeppers/master/images/constellations-amoled/AQUARIUS-amoled.png",
        "thumbnail": "https://raw.githubusercontent.com/undefyned/wallpeppers/master/images/thumbs/constellations-amoled/AQUARIUS-amoled.webp",
        "collections": "ALL,CONSTELLATION"
}, {
        "name": "Aries AMOLED",
        "author": "undefyned",
        "url": "https://raw.githubusercontent.com/undefyned/wallpeppers/master/images/constellations-amoled/ARIES-amoled.png",
        "thumbnail": "https://raw.githubusercontent.com/undefyned/wallpeppers/master/images/thumbs/constellations-amoled/ARIES-amoled.webp",
        "collections": "ALL,CONSTELLATION"
}, {
        "name": "Cancer AMOLED",
        "author": "undefyned",
        "url": "https://raw.githubusercontent.com/undefyned/wallpeppers/master/images/constellations-amoled/CANCER-amoled.png",
        "thumbnail": "https://raw.githubusercontent.com/undefyned/wallpeppers/master/images/thumbs/constellations-amoled/CANCER-amoled.webp",
        "collections": "ALL,CONSTELLATION"
}, {
        "name": "Capricorn AMOLED",
        "author": "undefyned",
        "url": "https://raw.githubusercontent.com/undefyned/wallpeppers/master/images/constellations-amoled/CAPRICORN-amoled.png",
        "thumbnail": "https://raw.githubusercontent.com/undefyned/wallpeppers/master/images/thumbs/constellations-amoled/CAPRICORN-amoled.webp",
        "collections": "ALL,CONSTELLATION"
}, {
        "name": "Gemini AMOLED",
        "author": "undefyned",
        "url": "https://raw.githubusercontent.com/undefyned/wallpeppers/master/images/constellations-amoled/GEMINI-amoled.png",
        "thumbnail": "https://raw.githubusercontent.com/undefyned/wallpeppers/master/images/thumbs/constellations-amoled/GEMINI-amoled.webp",
        "collections": "ALL,CONSTELLATION"
}, {
        "name": "Leo AMOLED",
        "author": "undefyned",
        "url": "https://raw.githubusercontent.com/undefyned/wallpeppers/master/images/constellations-amoled/LEO-amoled.png",
        "thumbnail": "https://raw.githubusercontent.com/undefyned/wallpeppers/master/images/thumbs/constellations-amoled/LEO-amoled.webp",
        "collections": "ALL,CONSTELLATION"
}, {
        "name": "Libra AMOLED",
        "author": "undefyned",
        "url": "https://raw.githubusercontent.com/undefyned/wallpeppers/master/images/constellations-amoled/LIBRA-amoled.png",
        "thumbnail": "https://raw.githubusercontent.com/undefyned/wallpeppers/master/images/thumbs/constellations-amoled/LIBRA-amoled.webp",
        "collections": "ALL,CONSTELLATION"
}, {
        "name": "Pisces AMOLED",
        "author": "undefyned",
        "url": "https://raw.githubusercontent.com/undefyned/wallpeppers/master/images/constellations-amoled/PISCES-amoled.png",
        "thumbnail": "https://raw.githubusercontent.com/undefyned/wallpeppers/master/images/thumbs/constellations-amoled/PISCES-amoled.webp",
        "collections": "ALL,CONSTELLATION"
}, {
        "name": "Sagittarius AMOLED",
        "author": "undefyned",
        "url": "https://raw.githubusercontent.com/undefyned/wallpeppers/master/images/constellations-amoled/SAGITTARIUS-amoled.png",
        "thumbnail": "https://raw.githubusercontent.com/undefyned/wallpeppers/master/images/thumbs/constellations-amoled/SAGITTARIUS-amoled.webp",
        "collections": "ALL,CONSTELLATION"
}, {
        "name": "Scorpio AMOLED",
        "author": "undefyned",
        "url": "https://raw.githubusercontent.com/undefyned/wallpeppers/master/images/constellations-amoled/SCORPIO-amoled.png",
        "thumbnail": "https://raw.githubusercontent.com/undefyned/wallpeppers/master/images/thumbs/constellations-amoled/SCORPIO-amoled.webp",
        "collections": "ALL,CONSTELLATION"
}, {
        "name": "Taurus AMOLED",
        "author": "undefyned",
        "url": "https://raw.githubusercontent.com/undefyned/wallpeppers/master/images/constellations-amoled/TAURUS-amoled.png",
        "thumbnail": "https://raw.githubusercontent.com/undefyned/wallpeppers/master/images/thumbs/constellations-amoled/TAURUS-amoled.webp",
        "collections": "ALL,CONSTELLATION"
}, {
        "name": "Virgo AMOLED",
        "author": "undefyned",
        "url": "https://raw.githubusercontent.com/undefyned/wallpeppers/master/images/constellations-amoled/VIRGO-amoled.png",
        "thumbnail": "https://raw.githubusercontent.com/undefyned/wallpeppers/master/images/thumbs/constellations-amoled/VIRGO-amoled.webp",
        "collections": "ALL,CONSTELLATION"
}, {
        "name": "Aquarius",
        "author": "undefyned",
        "url": "https://raw.githubusercontent.com/undefyned/wallpeppers/master/images/constellations/AQUARIUS.png",
        "thumbnail": "https://raw.githubusercontent.com/undefyned/wallpeppers/master/images/thumbs/constellations/AQUARIUS.webp",
        "collections": "ALL,CONSTELLATION"
}, {
        "name": "Aries",
        "author": "undefyned",
        "url": "https://raw.githubusercontent.com/undefyned/wallpeppers/master/images/constellations/ARIES.png",
        "thumbnail": "https://raw.githubusercontent.com/undefyned/wallpeppers/master/images/thumbs/constellations/ARIES.webp",
        "collections": "ALL,CONSTELLATION"
}, {
        "name": "Cancer",
        "author": "undefyned",
        "url": "https://raw.githubusercontent.com/undefyned/wallpeppers/master/images/constellations/CANCER.png",
        "thumbnail": "https://raw.githubusercontent.com/undefyned/wallpeppers/master/images/thumbs/constellations/CANCER.webp",
        "collections": "ALL,CONSTELLATION"
}, {
        "name": "Capricorn",
        "author": "undefyned",
        "url": "https://raw.githubusercontent.com/undefyned/wallpeppers/master/images/constellations/CAPRICORN.png",
        "thumbnail": "https://raw.githubusercontent.com/undefyned/wallpeppers/master/images/thumbs/constellations/CAPRICORN.webp",
        "collections": "ALL,CONSTELLATION"
}, {
        "name": "Gemini",
        "author": "undefyned",
        "url": "https://raw.githubusercontent.com/undefyned/wallpeppers/master/images/constellations/GEMINI.png",
        "thumbnail": "https://raw.githubusercontent.com/undefyned/wallpeppers/master/images/thumbs/constellations/GEMINI.webp",
        "collections": "ALL,CONSTELLATION"
}, {
        "name": "Leo",
        "author": "undefyned",
        "url": "https://raw.githubusercontent.com/undefyned/wallpeppers/master/images/constellations/LEO.png",
        "thumbnail": "https://raw.githubusercontent.com/undefyned/wallpeppers/master/images/thumbs/constellations/LEO.webp",
        "collections": "ALL,CONSTELLATION"
}, {
        "name": "Libra",
        "author": "undefyned",
        "url": "https://raw.githubusercontent.com/undefyned/wallpeppers/master/images/constellations/LIBRA.png",
        "thumbnail": "https://raw.githubusercontent.com/undefyned/wallpeppers/master/images/thumbs/constellations/LIBRA.webp",
        "collections": "ALL,CONSTELLATION"
}, {
        "name": "Pisces",
        "author": "undefyned",
        "url": "https://raw.githubusercontent.com/undefyned/wallpeppers/master/images/constellations/PISCES.png",
        "thumbnail": "https://raw.githubusercontent.com/undefyned/wallpeppers/master/images/thumbs/constellations/PISCES.webp",
        "collections": "ALL,CONSTELLATION"
}, {
        "name": "Sagittarius",
        "author": "undefyned",
        "url": "https://raw.githubusercontent.com/undefyned/wallpeppers/master/images/constellations/SAGITTARIUS.png",
        "thumbnail": "https://raw.githubusercontent.com/undefyned/wallpeppers/master/images/thumbs/constellations/SAGITTARIUS.webp",
        "collections": "ALL,CONSTELLATION"
}, {
        "name": "Scorpio",
        "author": "undefyned",
        "url": "https://raw.githubusercontent.com/undefyned/wallpeppers/master/images/constellations/SCORPIO.png",
        "thumbnail": "https://raw.githubusercontent.com/undefyned/wallpeppers/master/images/thumbs/constellations/SCORPIO.webp",
        "collections": "ALL,CONSTELLATION"
}, {
        "name": "Taurus",
        "author": "undefyned",
        "url": "https://raw.githubusercontent.com/undefyned/wallpeppers/master/images/constellations/TAURUS.png",
        "thumbnail": "https://raw.githubusercontent.com/undefyned/wallpeppers/master/images/thumbs/constellations/TAURUS.webp",
        "collections": "ALL,CONSTELLATION"
}, {
        "name": "Virgo",
        "author": "undefyned",
        "url": "https://raw.githubusercontent.com/undefyned/wallpeppers/master/images/constellations/VIRGO.png",
        "thumbnail": "https://raw.githubusercontent.com/undefyned/wallpeppers/master/images/thumbs/constellations/VIRGO.webp",
        "collections": "ALL,CONSTELLATION"
}, {
        "name": "Wow A Shark",
        "author": "undefyned",
        "url": "https://raw.githubusercontent.com/undefyned/wallpeppers/master/images/minimal/WOW%20A%20SHARK.png",
        "thumbnail": "https://raw.githubusercontent.com/undefyned/wallpeppers/master/images/thumbs/minimal/WOW%20A%20SHARK.webp",
        "collections": "ALL,MINIMAL"
}, {
        "name": "Knowerehere",
        "author": "undefyned",
        "url": "https://raw.githubusercontent.com/undefyned/wallpeppers/master/images/minimal/KNOWEREHERE.png",
        "thumbnail": "https://raw.githubusercontent.com/undefyned/wallpeppers/master/images/thumbs/minimal/KNOWEREHERE.webp",
        "collections": "ALL,MINIMAL"
}, {
        "name": "Knowerehere Dark",
        "author": "undefyned",
        "url": "https://raw.githubusercontent.com/undefyned/wallpeppers/master/images/minimal/KNOWEREHERE%20DARK.png",
        "thumbnail": "https://raw.githubusercontent.com/undefyned/wallpeppers/master/images/thumbs/minimal/KNOWEREHERE%20DARK.webp",
        "collections": "ALL,MINIMAL"
}, {
        "name": "Desert",
        "author": "undefyned",
        "url": "https://raw.githubusercontent.com/undefyned/wallpeppers/master/images/minimal/DESERT.png",
        "thumbnail": "https://raw.githubusercontent.com/undefyned/wallpeppers/master/images/thumbs/minimal/DESERT.webp",
        "collections": "ALL,MINIMAL"
}, {
        "name": "Desert Night",
        "author": "undefyned",
        "url": "https://raw.githubusercontent.com/undefyned/wallpeppers/master/images/minimal/DESERT%20NIGHT.png",
        "thumbnail": "https://raw.githubusercontent.com/undefyned/wallpeppers/master/images/thumbs/minimal/DESERT%20NIGHT.webp",
        "collections": "ALL,MINIMAL"
}, {
        "name": "Balloons",
        "author": "undefyned",
        "url": "https://raw.githubusercontent.com/undefyned/wallpeppers/master/images/space/BALLOONS.png",
        "thumbnail": "https://raw.githubusercontent.com/undefyned/wallpeppers/master/images/thumbs/space/BALLOONS.webp",
        "collections": "ALL,SPACE"
}, {
        "name": "Balloons AMOLED",
        "author": "undefyned",
        "url": "https://raw.githubusercontent.com/undefyned/wallpeppers/master/images/space/BALLOONS%20AMOLED.png",
        "thumbnail": "https://raw.githubusercontent.com/undefyned/wallpeppers/master/images/thumbs/space/BALLOONS%20AMOLED.webp",
        "collections": "ALL,SPACE"
}, {
        "name": "Gradient P Dark",
        "author": "undefyned",
        "url": "https://raw.githubusercontent.com/undefyned/wallpeppers/master/images/gradients/GRADIENT%20P%20DARK.png",
        "thumbnail": "https://raw.githubusercontent.com/undefyned/wallpeppers/master/images/thumbs/gradients/GRADIENT%20P%20DARK.webp",
        "collections": "ALL,GRADIENTS"
}, {
        "name": "Gradient P Light",
        "author": "undefyned",
        "url": "https://raw.githubusercontent.com/undefyned/wallpeppers/master/images/gradients/GRADIENT%20P%20LIGHT.png",
        "thumbnail": "https://raw.githubusercontent.com/undefyned/wallpeppers/master/images/thumbs/gradients/GRADIENT%20P%20LIGHT.webp",
        "collections": "ALL,GRADIENTS"
}, {
        "name": "Gradient BT",
        "author": "undefyned",
        "url": "https://raw.githubusercontent.com/undefyned/wallpeppers/master/images/gradients/GRADIENT%20BT.png",
        "thumbnail": "https://raw.githubusercontent.com/undefyned/wallpeppers/master/images/thumbs/gradients/GRADIENT%20BT.webp",
        "collections": "ALL,GRADIENTS"
}, {
        "name": "Gradient Midnight",
        "author": "undefyned",
        "url": "https://raw.githubusercontent.com/undefyned/wallpeppers/master/images/gradients/GRADIENT%20MIDNIGHT.png",
        "thumbnail": "https://raw.githubusercontent.com/undefyned/wallpeppers/master/images/thumbs/gradients/GRADIENT%20MIDNIGHT.webp",
        "collections": "ALL,GRADIENTS"
}, {
        "name": "Gradient X",
        "author": "undefyned",
        "url": "https://raw.githubusercontent.com/undefyned/wallpeppers/master/images/gradients/GRADIENT%20X.png",
        "thumbnail": "https://raw.githubusercontent.com/undefyned/wallpeppers/master/images/thumbs/gradients/GRADIENT%20X.webp",
        "collections": "ALL,GRADIENTS"
}, {
        "name": "Iridescent One",
        "author": "undefyned",
        "url": "https://raw.githubusercontent.com/undefyned/wallpeppers/master/images/gradients/IRIDESCENT%20ONE.png",
        "thumbnail": "https://raw.githubusercontent.com/undefyned/wallpeppers/master/images/thumbs/gradients/IRIDESCENT%20ONE.webp",
        "collections": "ALL,GRADIENTS"
}, {
        "name": "Iridescent Two",
        "author": "undefyned",
        "url": "https://raw.githubusercontent.com/undefyned/wallpeppers/master/images/gradients/IRIDESCENT%20TWO.png",
        "thumbnail": "https://raw.githubusercontent.com/undefyned/wallpeppers/master/images/thumbs/gradients/IRIDESCENT%20TWO.webp",
        "collections": "ALL,GRADIENTS"
}, {
        "name": "Rainbow",
        "author": "undefyned",
        "url": "https://raw.githubusercontent.com/undefyned/wallpeppers/master/images/gradients/RAINBOW.png",
        "thumbnail": "https://raw.githubusercontent.com/undefyned/wallpeppers/master/images/thumbs/gradients/RAINBOW.webp",
        "collections": "ALL,GRADIENTS"
}, {
        "name": "Tri Neon",
        "author": "undefyned",
        "url": "https://raw.githubusercontent.com/undefyned/wallpeppers/master/images/patterns/TRI%20NEON.png",
        "thumbnail": "https://raw.githubusercontent.com/undefyned/wallpeppers/master/images/thumbs/patterns/TRI%20NEON.webp",
        "collections": "ALL,PATTERNS"
}, {
        "name": "Tri Spiral",
        "author": "undefyned",
        "url": "https://raw.githubusercontent.com/undefyned/wallpeppers/master/images/patterns/TRI%20SPIRAL.png",
        "thumbnail": "https://raw.githubusercontent.com/undefyned/wallpeppers/master/images/thumbs/patterns/TRI%20SPIRAL.webp",
        "collections": "ALL,PATTERNS"
}, {
        "name": "Eleven",
        "author": "undefyned",
        "url": "https://raw.githubusercontent.com/undefyned/wallpeppers/master/images/patterns/ELEVEN.png",
        "thumbnail": "https://raw.githubusercontent.com/undefyned/wallpeppers/master/images/thumbs/patterns/ELEVEN.webp",
        "collections": "ALL,PATTERNS"
}, {
        "name": "Eleven AMOLED",
        "author": "undefyned",
        "url": "https://raw.githubusercontent.com/undefyned/wallpeppers/master/images/patterns/ELEVEN%20AMOLED.png",
        "thumbnail": "https://raw.githubusercontent.com/undefyned/wallpeppers/master/images/thumbs/patterns/ELEVEN%20AMOLED.webp",
        "collections": "ALL,PATTERNS"
}, {
        "name": "Buttons",
        "author": "undefyned",
        "url": "https://raw.githubusercontent.com/undefyned/wallpeppers/master/images/patterns/BUTTONS.png",
        "thumbnail": "https://raw.githubusercontent.com/undefyned/wallpeppers/master/images/thumbs/patterns/BUTTONS.webp",
        "collections": "ALL,PATTERNS"
}, {
        "name": "Buttons AMOLED",
        "author": "undefyned",
        "url": "https://raw.githubusercontent.com/undefyned/wallpeppers/master/images/patterns/BUTTONS%20AMOLED.png",
        "thumbnail": "https://raw.githubusercontent.com/undefyned/wallpeppers/master/images/thumbs/patterns/BUTTONS%20AMOLED.webp",
        "collections": "ALL,PATTERNS"
}, {
        "name": "Bubbles Amber",
        "author": "undefyned",
        "url": "https://raw.githubusercontent.com/undefyned/wallpeppers/master/images/patterns/BUBBLES%20AMBER.png",
        "thumbnail": "https://raw.githubusercontent.com/undefyned/wallpeppers/master/images/thumbs/patterns/BUBBLES%20AMBER.webp",
        "collections": "ALL,PATTERNS"
}, {
        "name": "Bubbles Teal",
        "author": "undefyned",
        "url": "https://raw.githubusercontent.com/undefyned/wallpeppers/master/images/patterns/BUBBLES%20TEAL.png",
        "thumbnail": "https://raw.githubusercontent.com/undefyned/wallpeppers/master/images/thumbs/patterns/BUBBLES%20TEAL.webp",
        "collections": "ALL,PATTERNS"
}, {
        "name": "Graph AMOLED",
        "author": "undefyned",
        "url": "https://raw.githubusercontent.com/undefyned/wallpeppers/master/images/patterns/GRAPH%20AMOLED.png",
        "thumbnail": "https://raw.githubusercontent.com/undefyned/wallpeppers/master/images/thumbs/patterns/GRAPH%20AMOLED.webp",
        "collections": "ALL,PATTERNS"
}, {
        "name": "Graph",
        "author": "undefyned",
        "url": "https://raw.githubusercontent.com/undefyned/wallpeppers/master/images/patterns/GRAPH.png",
        "thumbnail": "https://raw.githubusercontent.com/undefyned/wallpeppers/master/images/thumbs/patterns/GRAPH.webp",
        "collections": "ALL,PATTERNS"
}, {
        "name": "Gradient RP",
        "author": "undefyned",
        "url": "https://raw.githubusercontent.com/undefyned/wallpeppers/master/images/patterns/GRADIENT%20RP.png",
        "thumbnail": "https://raw.githubusercontent.com/undefyned/wallpeppers/master/images/thumbs/patterns/GRADIENT%20RP.webp",
        "collections": "ALL,PATTERNS"
}, {
        "name": "A Wallpepper",
        "author": "undefyned",
        "url": "https://raw.githubusercontent.com/undefyned/wallpeppers/master/images/patterns/A%20WALLPEPPER.png",
        "thumbnail": "https://raw.githubusercontent.com/undefyned/wallpeppers/master/images/thumbs/patterns/A%20WALLPEPPER.webp",
        "collections": "ALL,PATTERNS"
}, {
        "name": "Split Triangle",
        "author": "undefyned",
        "url": "https://raw.githubusercontent.com/undefyned/wallpeppers/master/images/patterns/SPLIT%20TRIANGLE.png",
        "thumbnail": "https://raw.githubusercontent.com/undefyned/wallpeppers/master/images/thumbs/patterns/SPLIT%20TRIANGLE.webp",
        "collections": "ALL,PATTERNS"
}, {
        "name": "Plus Pattern",
        "author": "undefyned",
        "url": "https://raw.githubusercontent.com/undefyned/wallpeppers/master/images/patterns/PLUS%20PATTERN.png",
        "thumbnail": "https://raw.githubusercontent.com/undefyned/wallpeppers/master/images/thumbs/patterns/PLUS%20PATTERN.webp",
        "collections": "ALL,PATTERNS"
}, {
        "name": "Retrowave One",
        "author": "undefyned",
        "url": "https://raw.githubusercontent.com/undefyned/wallpeppers/master/images/inspired/RETROWAVE%20ONE.png",
        "thumbnail": "https://raw.githubusercontent.com/undefyned/wallpeppers/master/images/thumbs/inspired/RETROWAVE%20ONE.webp",
        "collections": "ALL,INSPIRED"
}, {
        "name": "Retrowave Two",
        "author": "undefyned",
        "url": "https://raw.githubusercontent.com/undefyned/wallpeppers/master/images/inspired/RETROWAVE%20TWO.png",
        "thumbnail": "https://raw.githubusercontent.com/undefyned/wallpeppers/master/images/thumbs/inspired/RETROWAVE%20TWO.webp",
        "collections": "ALL,INSPIRED"
}, {
        "name": "iOS Inspired",
        "author": "undefyned",
        "url": "https://raw.githubusercontent.com/undefyned/wallpeppers/master/images/inspired/IOS%20INSPIRED.png",
        "thumbnail": "https://raw.githubusercontent.com/undefyned/wallpeppers/master/images/thumbs/inspired/IOS%20INSPIRED.webp",
        "collections": "ALL,INSPIRED"
}, {
        "name": "macOS Inspired",
        "author": "undefyned",
        "url": "https://raw.githubusercontent.com/undefyned/wallpeppers/master/images/inspired/MACOS%20INSPIRED.png",
        "thumbnail": "https://raw.githubusercontent.com/undefyned/wallpeppers/master/images/thumbs/inspired/MACOS%20INSPIRED.webp",
        "collections": "ALL,INSPIRED"
}, {
        "name": "NURKO",
        "author": "undefyned",
        "url": "https://raw.githubusercontent.com/undefyned/wallpeppers/master/images/exclusive/NURKO%20X%20RETROWAVE.png",
        "thumbnail": "https://raw.githubusercontent.com/undefyned/wallpeppers/master/images/thumbs/exclusive/NURKO%20X%20RETROWAVE.webp",
        "collections": "ALL,EXCLUSIVE"
}, {
        "name": "Apple Pie",
        "author": "undefyned",
        "url": "https://raw.githubusercontent.com/undefyned/wallpeppers/master/images/exclusive/APPLE%20PIE.png",
        "thumbnail": "https://raw.githubusercontent.com/undefyned/wallpeppers/master/images/thumbs/exclusive/APPLE%20PIE.webp",
        "collections": "ALL,EXCLUSIVE"
}, {
        "name": "Love Is Gone",
        "author": "undefyned",
        "url": "https://raw.githubusercontent.com/undefyned/wallpeppers/master/images/exclusive/LOVE%20IS%20GONE.png",
        "thumbnail": "https://raw.githubusercontent.com/undefyned/wallpeppers/master/images/thumbs/exclusive/LOVE%20IS%20GONE.webp",
        "collections": "ALL,EXCLUSIVE"
}, {
        "name": "Love Is Gone",
        "author": "undefyned",
        "url": "https://raw.githubusercontent.com/undefyned/wallpeppers/master/images/exclusive/LOVE%20IS%20GONE%20AMOLED.png",
        "thumbnail": "https://raw.githubusercontent.com/undefyned/wallpeppers/master/images/thumbs/exclusive/LOVE%20IS%20GONE%20AMOLED.webp",
        "collections": "ALL,EXCLUSIVE"
}, {
        "name": "Love Is Gone 2",
        "author": "undefyned",
        "url": "https://raw.githubusercontent.com/undefyned/wallpeppers/master/images/exclusive/LOVE%20IS%20GONE%202.png",
        "thumbnail": "https://raw.githubusercontent.com/undefyned/wallpeppers/master/images/thumbs/exclusive/LOVE%20IS%20GONE%202.webp",
        "collections": "ALL,EXCLUSIVE"
}, {
        "name": "Love Is Gone 2",
        "author": "undefyned",
        "url": "https://raw.githubusercontent.com/undefyned/wallpeppers/master/images/exclusive/LOVE%20IS%20GONE%202%20AMOLED.png",
        "thumbnail": "https://raw.githubusercontent.com/undefyned/wallpeppers/master/images/thumbs/exclusive/LOVE%20IS%20GONE%202%20AMOLED.webp",
        "collections": "ALL,EXCLUSIVE"
}
    ]

export default wallpaperList;